@if (!isIgnored) {
  <button
    authorizeEnable
    [disabled]="updating || !hasCreateAssetsPermission"
    [authorizeFeature]="isPremiumIntegrationFeature(integrationType)"
    type="button"
    class="btn btn-outline btn-sm me-2"
    (click)="addAsset()"
  >
    Add Asset
  </button>
  <button
    authorizeEnable
    [disabled]="updating || !hasCreateAssetsPermission"
    [authorizeFeature]="isPremiumIntegrationFeature(integrationType)"
    type="button"
    class="btn btn-outline btn-sm me-2"
    (click)="addCost()"
  >
    Add Cost
  </button>
  <button
    authorizeEnable
    [disabled]="updating || !hasCreateAssetsPermission"
    [authorizeFeature]="isPremiumIntegrationFeature(integrationType)"
    type="button"
    class="btn btn-outline btn-sm"
    (click)="onIgnore()"
  >
    Ignore
  </button>
}
